// src/hooks/currencies/useDeleteCurrency.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteCurrency } from "../../api/apiCurrencies";
import { useTranslation } from "react-i18next";

function useDeleteCurrency() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: deleteCurrencyMutation, isPending: isDelete } = useMutation({
        mutationFn: deleteCurrency,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["currencies"] });
            toast.success(isArabic ? "تم حذف العملة بنجاح" : "Currency deleted successfully");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في حذف العملة" : "Failed to delete currency"));
        },
    });

    return { deleteCurrency: deleteCurrencyMutation, isDelete };
}

export default useDeleteCurrency;
